import * as z from 'zod';
import { componentExtractionStatusSchema, financialPeriodPreparationMethodSchema, periodTypeSchema, extractionStatusSchema, ExtractionStatus, extractionErrorTypeSchema } from '../../../../enums.mjs';
import { isoDateSchema, fileId } from '../../../opaque.mjs';
import { BalanceSheetData } from './balance-sheet-data.mjs';
import { IncomeStatementData } from './income-statement-data.mjs';
import { StatementMetadata } from './statement-metadata.mjs';

var PeriodExtractionResult;
(function (PeriodExtractionResult) {
    PeriodExtractionResult.schema = z.object({
        periodEndDate: isoDateSchema,
        periodType: periodTypeSchema,
        statementDate: isoDateSchema,
        preparationMethod: financialPeriodPreparationMethodSchema,
        companyName: z.string().nullable(),
        isRestated: z.boolean(),
        balanceSheetOutput: BalanceSheetData.schema.nullable(),
        balanceSheetStatus: componentExtractionStatusSchema,
        incomeStatementOutput: IncomeStatementData.schema.nullable(),
        incomeStatementStatus: componentExtractionStatusSchema,
    });
})(PeriodExtractionResult || (PeriodExtractionResult = {}));
var ExtractionResultPayload;
(function (ExtractionResultPayload) {
    ExtractionResultPayload.schema = z.object({
        fileId: fileId,
        status: extractionStatusSchema.extract([ExtractionStatus.Completed, ExtractionStatus.Partial]),
        classificationOutput: StatementMetadata.schema,
        processingSessionId: z.string().nullable(),
        periods: z.tuple([PeriodExtractionResult.schema]).rest(PeriodExtractionResult.schema),
    });
})(ExtractionResultPayload || (ExtractionResultPayload = {}));
var ExtractionFailurePayload;
(function (ExtractionFailurePayload) {
    ExtractionFailurePayload.schema = z.object({
        fileId: fileId,
        status: z.literal("failed"),
        errorType: extractionErrorTypeSchema,
        errorMessage: z.string(),
    });
})(ExtractionFailurePayload || (ExtractionFailurePayload = {}));
var ExtractionWebhookPayload;
(function (ExtractionWebhookPayload) {
    ExtractionWebhookPayload.schema = z.discriminatedUnion("status", [
        ExtractionResultPayload.schema,
        ExtractionFailurePayload.schema,
    ]);
})(ExtractionWebhookPayload || (ExtractionWebhookPayload = {}));

export { ExtractionFailurePayload, ExtractionResultPayload, ExtractionWebhookPayload, PeriodExtractionResult };
